import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

const initialState = {
  data: [],
  loading: false,
  errorMessage: "",
};

// get notice
export const fetchNotice = createAsyncThunk(`notice/fetchNotice`, async () => {
  const response = await api.get("/notices/");
  // console.log("res", response);
  return response.data;
});

// add notice
export const createNotice = createAsyncThunk("", async (data) => {
  const response = await api.post("/notices/", data);
  return response.data;
});


// search notice
export const searchNotice = createAsyncThunk("", async (data) => {
  const response = await api.get(`/notices/?search=${data}`)
  return response.data
})


const noticeSlice = createSlice({
  name: "notice",
  initialState,
  reducers: {},

  extraReducers(builder) {
    builder
      .addCase(fetchNotice.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.errorMessage = "";
      })
      .addCase(fetchNotice.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      })

      // create Notice
      .addCase(createNotice.pending, (state) => {
        state.loading = true;
      })
      .addCase(createNotice.fulfilled, (state, action) => {
        state.loading = false;
        // state.data = action.payload;
        state.errorMessage = "";
      })
      .addCase(createNotice.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      });

      // search Notice
      // builder
      // .addCase(searchNotice.pending, (state) => {
      //   state.loading = true;
      // })
      // .addCase(searchNotice.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.data = action.payload;
      //   state.errorMessage = "";
      // })
      // .addCase(searchNotice.rejected, (state, action) => {
      //   state.loading = false;
      //   state.errorMessage = action.payload;
      // })




  },
});

export default noticeSlice.reducer;
